import { render, staticRenderFns } from "./indonesian_leadership_training.vue?vue&type=template&id=3e63b64c&scoped=true"
import script from "./indonesian_leadership_training.vue?vue&type=script&lang=js"
export * from "./indonesian_leadership_training.vue?vue&type=script&lang=js"
import style0 from "./indonesian_leadership_training.vue?vue&type=style&index=0&id=3e63b64c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e63b64c",
  null
  
)

export default component.exports